import React from 'react';
import { ItemValue } from 'survey-core';
import { Grid, Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { getTierName } from '../helpers/customFunctions';

type Props = {
  choices: ItemValue[];
  strings: string;
  getIcon: (text: string) => string;
};

const useStyles = makeStyles(theme =>
  createStyles({
    paper: {
      width: '430px',
      flexDirection: 'column',
      padding: theme.spacing(3),
      paddingTop: 0,
      display: 'flex',
      alignItems: 'center',
      background: 'var(--light-gray-paper)',
      border: '1px solid var(--on-surface-outline-000000-12-)'
    },
    title: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      margin: theme.spacing(3, 1, 1.5),
      '& > h6': {
        fontSize: 24
      }
    },
    logo: {
      width: '70px',
      marginRight: theme.spacing(2)
    },
    text: {
      fontSize: '12px',
      lineHeight: '16px'
    }
  })
);

export const SubscriptionAU: React.FC<Props> = ({ choices, strings, getIcon }) => {
  const classes = useStyles();

  return (
    <Grid container justify="center">
      {choices.map(({ value, text }: ItemValue) => (
        <Paper elevation={0} className={classes.paper} key={value}>
          <div className={classes.title}>
            <div className={classes.logo}>
              <img alt={text} src={`${process.env.PUBLIC_URL}${getIcon(text)}`} />
            </div>
            <Typography variant="h6">{getTierName(text)}</Typography>
          </div>
          <Typography className={classes.text}>{strings}</Typography>
        </Paper>
      ))}
    </Grid>
  );
};
